
import { Component, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { stringify } from 'querystring';


import {LiveAnnouncer} from '@angular/cdk/a11y';
import {C, COMMA, ENTER} from '@angular/cdk/keycodes';
import {ChangeDetectionStrategy, computed, inject, model, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MatAutocompleteModule, MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {MatChipInputEvent, MatChipsModule} from '@angular/material/chips';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';

	
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DataSource } from '@angular/cdk/collections';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { MatOption, MatSelect } from '@angular/material/select';

import { Constants } from 'src/app/domain/const/constants';
import { Router } from '@angular/router';
import { ConfirmDialogComponent } from '../../catalogue-devices/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogAlertsComponent } from '../confirm-dialog-alerts/confirm-dialog-alerts.component';
import { takeUntil } from 'rxjs/operators';
import { PropertiesTowers } from 'src/app/services/dashboards/propertiesTower.service';
import { Subject, Subscription } from 'rxjs';


export interface PeriodicElement {
  days: string;
  from: string;
  to: string;
  delete:string;
  deviceId:number;
  typeAlert:TypesAlert[],
  numberOfDays:any[]
  
}


/*export interface PeriodicElement {
  days: string;
  from: string;
  to: string;
  delete:string;
  deviceId:number;
  typeAlert:string;
  alerts:string;
  
  
}*/

export interface TypesAlert{
  emails: string;
  whatsApps: string;
}


@Component({
  selector: 'neoris-settings-update-devices',
   templateUrl: './settings-update-devices.component.html',
  styleUrl: './settings-update-devices.component.css',
  animations: [
    trigger('detailExpand', [
    state('collapsed', style({height: '0px', minHeight: '0', display: 'none'})),
    state('expanded', style({height: '*'})),
    transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
  ]),
],
})
export class SettingsUpdateDevicesComponent {
  IsVisibleEmail :boolean = false;
  IsVisibleWhatsApp :boolean = false;
  IsVisibleSirenAlert :boolean = false; 
  dataSource=new MatTableDataSource
  ELEMENT_DATA:PeriodicElement[] = []
  displayedColumns: string[] = ['days', 'from', 'to','delete'];
  displayedColumnsChildren: string[] = ['emails','whatsApps'];
  columnsToDisplay = ['email'];
  //dataSource = new MatTableDataSource(ELEMENT_DATA);
  dataChildren:any[] = []
  expandedElement: TypesAlert[] =  [{emails:'hola@me.com',whatsApps:'2761277638'}];
  formAISettingCamera:UntypedFormGroup = new UntypedFormGroup({})
  request:any={}
  detailConfigurationAlertDto:any={}
  arrayDetailConfigurationAlertDto:any[] = []
  arrayRequest:any[] = [] 
  arrayTemplateAlert:any[]=[]
  _site:string
  arrayIncidentsTypes:any[] = []
  strTranslate:string
  public arrayCodeSeverity: any[] = []  
  public arrayTypesAlert: any[] = []  
  private onLanChange:Subscription
  detailNotifications:any[] = []  
  detailAlerts:any[] = []
  numbers: number[] = [];
  

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  readonly currentFruit = model('');
  readonly contact = signal(['']);
  optionNameRadio :string=''
  private unsubscribe$: Subject<any> = new Subject<any>();
  private onClick:Subscription

  
  get filteredItems() {
    return this.arrayTemplateAlert.filter(item => item.name.toLowerCase() == this.optionNameRadio.toLowerCase());
  }

  allContacts:any[] = []
  /*readonly allContacts:any=[{email:'roberto1@me.com',whatsapp:'2761277638',sirene:''},
    {email:'juan2@me.com',whatsapp:'2223456777',sirene:''},
    {email:'emanuel@me.com',whatsapp:'2111679988',sirene:''}
  ];*/ 
  readonly filteredFruits = computed(() => {
    const currentFruit = this.currentFruit().toLowerCase();
    if(this.IsVisibleEmail){
    return currentFruit
      ? this.allContacts.filter(contact => contact.email.toLowerCase().includes(currentFruit))
      : this.allContacts.slice();
    }else if(this.IsVisibleWhatsApp){
      return currentFruit
      ? this.allContacts.filter(contact => contact.whatsapp.toLowerCase().includes(currentFruit))
      : this.allContacts.slice(); 
    }
  });

  readonly announcer = inject(LiveAnnouncer);
  
  filters = new UntypedFormGroup({
    severityType: new UntypedFormControl('',Validators.required),
    incidentType: new UntypedFormControl('',Validators.required),
    
  });

  
 


  
  @ViewChild('selIncidentType') selIncidentType: MatSelect;
  @ViewChild('selSeverityType') selSeverityType: MatSelect;
  
  @ViewChild('alarmTypeSelect') alarmTypeSelect: MatSelect;


  constructor(
    private fb: UntypedFormBuilder,
    private controltowerservice:ControltowerService,
    private _snackBar:MatSnackBar,
    private translate: TranslateService,
    private route:Router,
    public dialog: MatDialog,
    private propertiesService:PropertiesTowers,
  ) { 
    this.formAISettingCamera = this.fb.group({
      isvalidMonday: ( [false, []]),
      isvalidTuesday: ( [false, []]),
      isvalidWednesday: ( [false, []]),
      isvalidThursDay: ( [false, []]),
      isvalidFriday: ( [false, []]),
      isvalidSaturday: ( [false, []]),
      isvalidSunday: ( [false, []]),
      
      options:  (['', [Validators.required]]),
      from: ( ['', [Validators.required]]),
      to: ( ['', [Validators.required]]),
      template:  [''],
      optionAlert:  ( ['', [Validators.required]]),
      currentFruit:  ( ['', [Validators.required]]),
      alarmType:  ( ['', [Validators.required]]),
    

    
    
  
    });
  }

  get alarmType(){
    return this.formAISettingCamera.controls
  }

  get severityType(){
    return this.filters.controls
  }

  get incidentType(){
    return this.filters.controls
  }

  get optionAlert(){
    return this.formAISettingCamera.controls
  }

  get options(){
    return this.formAISettingCamera.controls
  }

  get template(){
    return this.formAISettingCamera.controls
  }

 
  


  get isvalidMonday(){
    return this.formAISettingCamera.controls
  }

  get isvalidTuesday(){
    return this.formAISettingCamera.controls
  }
  get isvalidWednesday(){
    return this.formAISettingCamera.controls
  }
  get isvalidThursDay(){
    return this.formAISettingCamera.controls
  }

  get isvalidFriday(){
    return this.formAISettingCamera.controls
  }
  get isvalidSaturday(){
    return this.formAISettingCamera.controls
  }
  get isvalidSunday(){
    return this.formAISettingCamera.controls
  }

  @ViewChild(MatSelect) matSelect: MatSelect;

  

  async ngOnInit(): Promise<void>  {
    //this.ELEMENT_DATA.push({days: 'lunes,martes', from: '10:00 a.m', to: '01:00 p.m'})
    //this.ELEMENT_DATA.push({days: 'miercoles, jueves', from: '02:00 p.m', to: '08:00 p.m'})

    //console.log('datos a la table',this.ELEMENT_DATA)
    //console.log('display header',this.displayedColumns)
    //this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
    this._site = localStorage.getItem('site')
    console.log('valor de site:',this._site)



    this.onLanChange = this.translate.onLangChange.subscribe(s => {
      console.log("idioma",s.lang)
      this.strTranslate = s.lang != undefined ? s.lang : "en";
      let succesGeneric = this.getGenericAtrributeValue(this.strTranslate)
      let SubjectIncidentsTypes = this.getIncidentsTypes()
    })

    console.log('ssss',this.strTranslate)
    if(this.strTranslate == undefined){
      this.strTranslate = 'en'
    let succesGeneric = this.getGenericAtrributeValue('en')
    let SubjectIncidentsTypes = this.getIncidentsTypes()
    }

    



    await this.getContacsAll()

    await this.getNotificationsConfigurationsl()

    this.formAISettingCamera.controls['alarmType'].valueChanges.subscribe(async (value) => {
      console.log('alarmType changed:', value);
      //await this.triggerAlarmTypeChange(value);
    });

    this.onClick = this.propertiesService.clickBtnAddDevice.pipe(takeUntil(this.unsubscribe$)).subscribe(async (value) => {
      console.log('valor recibido de click en el form',value)
      if(value){
        await this.bindData()
      }
    })

    

  }


 
  


  async bindData(){
   
    const rowSelectUpdateAlert: any = JSON.parse(localStorage.getItem('rowSelectUpdateAlert'))
    console.log('valor de rowSelectUpdateAlert:',rowSelectUpdateAlert)
    console.log('valor de severityTypeId:',rowSelectUpdateAlert.severityTypeId) 

    this.selSeverityType.options.forEach(async f => {
     

        if (f.value.id == rowSelectUpdateAlert.severityTypeId) {

          f.select()
        }
      

    })

    this.selIncidentType.options.forEach(async f => {
     

      if (f.value.id == rowSelectUpdateAlert.eventTypeId) {

        f.select()
      }
    

  })

    await this.GetConfigurationAlertByDeviceId(rowSelectUpdateAlert.eventTypeId,rowSelectUpdateAlert.severityTypeId,Number(localStorage.getItem('sourceDeviceId')))
  
    /*this.filters.patchValue({
      severityType: [rowSelectUpdateAlert.severityTypeId]
    });*/
    //this.filters.setValue([rowSelectUpdateAlert.severityTypeId]);
    //this.filters.controls["severityType"].setValue([rowSelectUpdateAlert.severityTypeId])
   this.formAISettingCamera.controls['options'].setValue(rowSelectUpdateAlert.always == true ? '1' : '2')
    //this.formAISettingCamera.controls['alarmType'].setValue(rowSelectUpdateAlert.typeAlertId,{emitEvent:true})

    //this.optionNameRadio = Constants.NAME_EMAIL
    this.formAISettingCamera.controls['template'].setValue(12)
    
    this.formAISettingCamera.controls['from'].setValue(rowSelectUpdateAlert.id)
    this.formAISettingCamera.controls['to'].setValue(rowSelectUpdateAlert.id)
   
    this.formAISettingCamera.controls['optionAlert'].setValue(rowSelectUpdateAlert.id)
    this.formAISettingCamera.controls['currentFruit'].setValue(rowSelectUpdateAlert.id)
    //this.formAISettingCamera.controls['alarmType'].setValue(rowSelectUpdateAlert.typeAlertId)
    
    /*this.formAISettingCamera.controls['isvalidMonday'].setValue(rowSelectUpdateAlert.id)
    this.formAISettingCamera.controls['isvalidTuesday'].setValue(rowSelectUpdateAlert.id)
    this.formAISettingCamera.controls['isvalidWednesday'].setValue(rowSelectUpdateAlert.id)
    this.formAISettingCamera.controls['isvalidFriday'].setValue(rowSelectUpdateAlert.id)
    this.formAISettingCamera.controls['isvalidSaturday'].setValue(rowSelectUpdateAlert.id)
    this.formAISettingCamera.controls['isvalidSunday'].setValue(rowSelectUpdateAlert.id)
*/

  }
  
  toggleAllSelection(matSelect: MatSelect) {
    const isSelected: boolean = matSelect.options
      // The "Select All" item has the value 0, so find that one
      .filter((item: MatOption) => item.value === 0)
      // Get the value of the property 'selected' (this tells us whether "Select All" is selected or not)
      .map((item: MatOption) => item.selected)
      // Get the first element (there should only be 1 option with the value 0 in the select)
      [0];

    if (isSelected) {
      matSelect.options.forEach((item: MatOption) => item.select());
    } else {
      matSelect.options.forEach((item: MatOption) => item.deselect());
    }
    
    console.log('valor de matSelect:',matSelect)
}


  openSnackBar(message: string, action: string) {
    if(action == 'OK'){
    this._snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['blue-snackbar']
    });
  }
  else{
    this._snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['blue-snackbar-false']
    });
  }
  }


  radioChange(event: any) {
    console.log('valor de radio--------------->:',event)
    if(event.value == '13203'){
      this.optionNameRadio = Constants.NAME_EMAIL
      this.IsVisibleWhatsApp = false
      
      this.IsVisibleEmail = true

    }else if(event.value == '13204'){
      this.optionNameRadio = Constants.NAME_WHATSAPP
      this.IsVisibleEmail = false
      this.IsVisibleWhatsApp = true
    }else{
      this.IsVisibleSirenAlert = true
    }

    
}

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    console.log('valor de value:',value)
    // Add our fruit
    if (value) {
      this.contact.update(fruits => [...fruits, value]);
    }

    // Clear the input value
    this.currentFruit.set('');
  }


  remove(fruit: string): void {
    this.contact.update(fruits => {
      const index = fruits.indexOf(fruit);
      if (index < 0) {
        return fruits;
      }

      fruits.splice(index, 1);
      this.announcer.announce(`Removed ${fruit}`);
      return [...fruits];
    });
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    console.log('valor de event:',event.option.viewValue)
    this.contact.update(fruits => [...fruits, event.option.viewValue]);
    this.currentFruit.set('');
    event.option.deselect();
  }

  async save(){

    let severity = this.filters.get('severityType').value
    let incidentType = this.filters.get('incidentType').value  
    console.log('valor de dataSource:',this.dataSource.data) 

    console.log('valor de severity:',severity)
    console.log('valor de incidentType:',incidentType)

    //const data = this.dataSource.data;

    const data : PeriodicElement[] = this.dataSource.data as PeriodicElement[];

   
    console.log('valor de data:',data)

   
    data.forEach(item => {
      const array: string[] = item.days.split(',');
      console.log('valor de array para el request:', item);
    
      // Crear una nueva instancia de detailConfigurationAlertDto en cada iteración
      const detailConfigurationAlertDto = {
        days: array.filter(item => item && item.trim().length > 0),
        from: item.from,
        to: item.to,
        deviceId: item.deviceId,
        typeAlert: item.typeAlert
        
      };
    
      this.arrayDetailConfigurationAlertDto.push(detailConfigurationAlertDto);
    });

    console.log('valor de arrayDetailConfigurationAlertDto:',this.arrayDetailConfigurationAlertDto)



    this.request.detailConfigurationAlertDto = this.arrayDetailConfigurationAlertDto
    this.request.SIteId = this._site
    this.request.localCode = 'es'
    this.request.sourceDeviceId = Number(localStorage.getItem('sourceDeviceId'))
    this.request.IsAlways = this.formAISettingCamera.value.options == '1' ? true : false
    this.request.eventTypeId = incidentType
    this.request.severityTypeId = severity
    this.request.isUpdate = true;


    console.log('request enviado---->',this.request)

    let exito = await this.SaveConfigurationAlertDetail(this.request);

    if(exito){
      console.log('entre en uno')
      this.openSnackBar(this.translate.instant('ALERT_SUCCESS'),"OK")
      this.route.navigate(["/ai-setting-camera"]);
 
    }
    else{
      console.log('entre en dos')
      this.openSnackBar(this.translate.instant('ALERT_FAILED'),"FAILED")
     
    }






    
  }

  close(){
   
  }


  addArmingShedule(){
    let dayStr = ''    
    let valueFrom = ''
    let valueTo =''

    console.log('valor monday:',this.formAISettingCamera.value)

    dayStr = this.formAISettingCamera.value.isvalidMonday == true ? 'Monday' : ''
    console.log('valor de dayStr:',dayStr)
    dayStr += this.formAISettingCamera.value.isvalidTuesday == true ?  ',Tuesday' : ''
    dayStr += this.formAISettingCamera.value.isvalidWednesday == true ? ',Wednesday' : ''
    dayStr += this.formAISettingCamera.value.isvalidThursDay == true ?  ',Thursday' : ''
    dayStr += this.formAISettingCamera.value.isvalidFriday == true ? ',Friday' : '' 
    dayStr += this.formAISettingCamera.value.isvalidSaturday == true ?  ',Saturday' : '' 
    dayStr += this.formAISettingCamera.value.isvalidSunday == true ?  ',Sunday' : ''

    this.GetFormValues()
    
    if(dayStr == ""){
      this.openSnackBar(this.translate.instant('SELECT_DAY'),"FAILED")
      return
    }

    console.log('option from:',this.formAISettingCamera.value.options)
    if(this.formAISettingCamera.value.options == '2'){ //from to
      valueFrom = this.formAISettingCamera.value.from
      valueTo = this.formAISettingCamera.value.to


      if(valueFrom == "" || valueTo == ""){
        this.openSnackBar(this.translate.instant('SELECT_FROM_TO'),"FAILED")
        return
      }
    }


    
    console.log('valor de ELEMENT_DATA:',this.ELEMENT_DATA)
    console.log('valor de dataSource:',this.dataSource) 

    console.log('valor de contact:', this.contact());

    if(this.formAISettingCamera.value.template == "" || this.formAISettingCamera.value.template == null){
      this.openSnackBar(this.translate.instant('SELECT_TYPE_ALERT'),"FAILED")
      return
    }



    this.dataChildren = []

      for (let clave of this.contact()) {
        if (clave.includes('@')) {
          console.log('Es un email:', clave);
          this.dataChildren.push({alerts:clave,typeAlert:'EMAIL',typeAlertId:this.formAISettingCamera.value.template})
        } else if (clave.match(/^\d+$/)) {
          console.log('Es un número de WhatsApp:', clave);
          this.dataChildren.push({alerts:clave,typeAlert:'WHATSAPP',typeAlertId:this.formAISettingCamera.value.template})
        } else {
          console.log('Valor no reconocido:', clave);
        }
      }

      var option = this.formAISettingCamera.get('options').value

      if(option == ""){
        this.openSnackBar(this.translate.instant('SELECT_OPTION'),"FAILED")
        return

      }

      console.log('valor de option:',option)
      if(option == '2'){ // from to
      if(this.formAISettingCamera.get('isvalidMonday').value == false && this.formAISettingCamera.get('isvalidTuesday').value == false && this.formAISettingCamera.get('isvalidWednesday').value == false && this.formAISettingCamera.get('isvalidThursDay').value == false && this.formAISettingCamera.get('isvalidFriday').value == false && this.formAISettingCamera.get('isvalidSaturday').value == false && this.formAISettingCamera.get('isvalidSunday').value == false){ 
        this.openSnackBar(this.translate.instant('SELECT_DAY'),"FAILED")
        return


      }
    }

      if(this.dataChildren.length == 0){
        this.openSnackBar(this.translate.instant('SELECT_CONTACT'),"FAILED")
        return

      }


      let IsValid=this.ValidDaysOfWeek(this.ELEMENT_DATA,this.numbers)  
      console.log('valor de IsValid:',IsValid)
      if(!IsValid){
        this.openSnackBar(this.translate.instant('VALID_SELECT_DAYS'),"FAILED")
        return
      }


    //let numberOfDays = this.numbers == undefined ? [] : this.numbers

    let sourceDeviceId = Number(localStorage.getItem('sourceDeviceId'))
    this.ELEMENT_DATA.push({days: dayStr, from: valueFrom, to: valueTo,delete:'',deviceId :sourceDeviceId,typeAlert:this.dataChildren,numberOfDays:this.numbers})

    console.log('valor de ELEMENT_DATA:',this.ELEMENT_DATA) 

    this.dataSource = new MatTableDataSource<PeriodicElement>(this.ELEMENT_DATA);

  }

  /*addArmingSheduleNew(){
    let dayStr = ''    
    let valueFrom = ''
    let valueTo =''

    console.log('valor monday:',this.formAISettingCamera.value)

    dayStr = this.formAISettingCamera.value.isvalidMonday == true ? 'Monday' : ''
    console.log('valor de dayStr:',dayStr)
    dayStr += this.formAISettingCamera.value.isvalidTuesday == true ?  ',Tuesday' : ''
    dayStr += this.formAISettingCamera.value.isvalidWednesday == true ? ',Wednesday' : ''
    dayStr += this.formAISettingCamera.value.isvalidThursDay == true ?  ',Thursday' : ''
    dayStr += this.formAISettingCamera.value.isvalidFriday == true ? ',Friday' : '' 
    dayStr += this.formAISettingCamera.value.isvalidSaturday == true ?  ',Saturday' : '' 
    dayStr += this.formAISettingCamera.value.isvalidSunday == true ?  ',Sunday' : ''


    console.log('option from:',this.formAISettingCamera.value.options)
    if(this.formAISettingCamera.value.options == '2'){ //from to
      valueFrom = this.formAISettingCamera.value.from
      valueTo = this.formAISettingCamera.value.to
    }

    
    console.log('valor de ELEMENT_DATA:',this.ELEMENT_DATA)
    console.log('valor de dataSource:',this.dataSource) 

    console.log('valor de contact:', this.contact());

    if(this.formAISettingCamera.value.template == "" || this.formAISettingCamera.value.template == null){
      this.openSnackBar("Select the type alert","FAILED")
      return
    }



    this.dataChildren = []

      for (let clave of this.contact()) {
        if (clave.includes('@')) {
          console.log('Es un email:', clave);
          this.ELEMENT_DATA.push({alerts:clave,typeAlert:'EMAIL',typeAlertId:this.formAISettingCamera.value.template})
        } else if (clave.match(/^\d+$/)) {
          console.log('Es un número de WhatsApp:', clave);
          this.ELEMENT_DATA.push({alerts:clave,typeAlert:'WHATSAPP',typeAlertId:this.formAISettingCamera.value.template})
        } else {
          console.log('Valor no reconocido:', clave);
        }
      }

      var option = this.formAISettingCamera.get('options').value

      if(option == ""){
        this.openSnackBar("Select option always/from","FAILED")
        return

      }

      console.log('valor de option:',option)
      if(option == '2'){ // from to
      if(this.formAISettingCamera.get('isvalidMonday').value == false && this.formAISettingCamera.get('isvalidTuesday').value == false && this.formAISettingCamera.get('isvalidWednesday').value == false && this.formAISettingCamera.get('isvalidThursDay').value == false && this.formAISettingCamera.get('isvalidFriday').value == false && this.formAISettingCamera.get('isvalidSaturday').value == false && this.formAISettingCamera.get('isvalidSunday').value == false){ 
        this.openSnackBar("Select the days","FAILED")
        return


      }
    }

      if(this.dataChildren.length == 0){
        this.openSnackBar("Select the contact","FAILED")
        return
      }

    let sourceDeviceId = Number(localStorage.getItem('sourceDeviceId'))
    //this.ELEMENT_DATA.push({days: dayStr, from: valueFrom, to: valueTo,delete:'',deviceId :sourceDeviceId,typeAlert:this.dataChildren})
    this.dataChildren.push({days: dayStr, from: valueFrom, to: valueTo,delete:'',deviceId :sourceDeviceId,typeAlert:this.dataChildren})


    console.log('valor de ELEMENT_DATA:',this.ELEMENT_DATA) 

    this.dataSource = new MatTableDataSource<PeriodicElement>(this.ELEMENT_DATA);

  }*/

  

  removeRow(element: any){
    const index = this.ELEMENT_DATA.indexOf(element);
    if (index >= 0) {
      console.log('valor de row removido es---->:', index);
      this.ELEMENT_DATA.splice(index, 1);
      this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
    }
  }


  private async getContacsAll(): Promise<boolean> {


    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.GetAllAcontacs().subscribe(
        {
            next: (contact: any) => {

              contact.data.forEach((item: any) => {
                //console.log('valor de item:',item)
                this.allContacts.push({
                  email: item.email,
                  whatsapp: item.whatsapp,
                  sirene: ''
                });
              });
              //this.arrayIncidentsTypes = incidentype
              console.log('get values contacs--->',contact)
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }


  checkValue(value:any){

    console.log('get value selected template',value)

  }

  
  private async getNotificationsConfigurationsl(): Promise<boolean> {


    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.GetConfigurationsNotifications(parseInt(this._site)).subscribe(
        {

          next: (cofigNotifications: any) => {
              //this.arrayIncidentsTypes = incidentype
              this.arrayTemplateAlert = cofigNotifications.data
              console.log('get values array templates--->',cofigNotifications)
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }


  private async SaveConfigurationAlertDetail(request:any): Promise<any> {
    
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.saveConfigurationAlertDetail(request).subscribe(
        {
          next: (report: any) => {
            console.log('respondio el save reporte--->:',report);
                                  
            resolve(report);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }


  private async getIncidentsTypes(): Promise<boolean> {


    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getIncidentsTypes(this.strTranslate).subscribe(
        {

          next: (incidentype: any) => {
              this.arrayIncidentsTypes = incidentype
              console.log('obtener values select--->',incidentype)
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  ValidDaysOfWeek(data: any[], dataNumbers: any[]): boolean {
    let isValid = true;
  
    console.log('valor de data:',data)
    data.some(item => {
      return item.numberOfDays.some(itemdays => {
        return dataNumbers.some(item2 => {
          if (itemdays === item2) {
            console.log('valor de item:', item);
            console.log('valor de item2:', item2);
            console.log('valor de itemdays:', itemdays);
            isValid = false;
            return true; // Esto detiene el bucle `some`
          }
          return false;
        });
      });
    });
  
    return isValid;
  }


GetFormValues(): void {
  Object.keys(this.formAISettingCamera.controls).forEach(key => {
    const control = this.formAISettingCamera.get(key);

    if(key == "isvalidMonday"){  
      if(control?.value){
        this.addNumberDayOfWeek(1)
      }
      
    }
    else if(key == "isvalidTuesday"){
      if(control?.value){
        this.addNumberDayOfWeek(2)
      }
      
    }
    else if(key == "isvalidWednesday"){
      if(control?.value){
        this.addNumberDayOfWeek(3)
      }
    
    }
    else if(key == "isvalidThursDay"){
      if(control?.value){
        this.addNumberDayOfWeek(4)
      }
      
    }
    else if(key == "isvalidFriday"){
      if(control?.value){
        this.addNumberDayOfWeek(5)
      }
     
    }
    else if(key == "isvalidSaturday"){
      if(control?.value){
        this.addNumberDayOfWeek(6)
      }
      
    }
    else if(key == "isvalidSunday"){
      if(control?.value){
        this.addNumberDayOfWeek(7)
      }
      
    }
    console.log(`Control Name: ${key}, Value: ${control?.value}`);
  });
}


addNumberDayOfWeek(newNumber: number): void {
  this.numbers.push(newNumber);
  console.log("Dias agregados",this.numbers)
}

  

  base64ToBytes(base64: string): Uint8Array {
    // Decodificar la cadena Base64
    const binaryString = atob(base64);
    
    // Crear un array de bytes con la longitud de la cadena decodificada
    const bytes = new Uint8Array(binaryString.length);
    
    // Llenar el array de bytes con los valores de la cadena decodificada
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    
    return bytes;
  }

  private async getGenericAtrributeValue(localCode:string): Promise<boolean> {
   

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getAttributeValue(localCode).subscribe(
        {
          next: (attribute: any={}) => {
            console.log('estos son los atrributos:',attribute)
            for(let i=0;i<= attribute.attributeTypes.length -1;i++){
              console.log('si entre')
              if(attribute.attributeTypes[i].id == 8){
                this.arrayCodeSeverity = attribute.attributeTypes[i].attributeValues

              }

              if(attribute.attributeTypes[i].id == 56){
                this.arrayTypesAlert = attribute.attributeTypes[i].attributeValues

              }
            }

            console.log('this.arrayCodeSeverity',this.arrayCodeSeverity)
           
            
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }


  private async GetIsValidSeverityEventAlerts(arrSeverity:any[],arrEvent:any[],sourceDeviceId:number): Promise<boolean> {
   

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.GetIsValidSeverityEventAlerts(arrEvent,arrSeverity,sourceDeviceId).subscribe(
        {
          next: (validate: boolean) => {
            
            
            
            resolve(validate);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }


  private async GetConfigurationAlertByDeviceId(eventTypeId:number,severityTypeId:number,sourceDeviceId:number): Promise<boolean> {
   

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.GetConfigurationAlertByDeviceId(eventTypeId,severityTypeId,sourceDeviceId).subscribe(
        {
          next: (detail: any={}) => {
            
    console.log('Obtener valores de alertas:',detail)
             
    detail.forEach(item => {
     
      /*item.typesAlerts.forEach((item1: any) => {

        const detailAlerts = {
          alerts: item1.alerts,
          typeAlert:item1.typeAlert
        }

        this.detailAlerts.push(detailAlerts);

      });*/

      const detailConfigurationDto = {
        days: item.days,
        from: item.from,
        to: item.to,
        deviceId: item.sourceDeviceId,
        SourceDeviceIdAlertId: item.sourceDeviceIdAlertId,
        typeAlert: item.typeAlert,
        arrayTypesAlerts : item.typesAlerts,
        numberOfDays: item.numberOfDays
      };
    
      this.ELEMENT_DATA.push({days: detailConfigurationDto.days, from: detailConfigurationDto.from, to: detailConfigurationDto.to,delete:'',deviceId :detailConfigurationDto.deviceId,typeAlert:detailConfigurationDto.arrayTypesAlerts,numberOfDays:detailConfigurationDto.numberOfDays})  

      //this.detailNotifications.push(detailConfigurationDto);
    });

            
            this.dataSource = new MatTableDataSource<PeriodicElement>(this.ELEMENT_DATA);
            this.dataChildren = this.detailAlerts
            console.log('valor de dataChildren:',this.dataChildren)
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }


  async validateSeverityAndEventTypeAlert(){
    const data : PeriodicElement[] = this.dataSource.data as PeriodicElement[];
    if(data.length == 0){
      this.openSnackBar("Add the detail of alert","FAILED")  
      return
    }


    let severity = this.filters.get('severityType').value
    let incidentType = this.filters.get('incidentType').value  
    let sourceDeviceId = Number(localStorage.getItem('sourceDeviceId'))
    console.log('valores enviados:',severity)
    let isValid = await this.GetIsValidSeverityEventAlerts(severity,incidentType,sourceDeviceId)


    if(!isValid){
      //await this.openConfirmDialog()
    }
    else{
      await this.save()
    }

  }

  async openConfirmDialog(element:any){
   
    console.log('openConfirmDialog')
    const dialogRef = this.dialog.open(ConfirmDialogAlertsComponent);

     dialogRef.afterClosed().subscribe(async result => {
      if (result) {

        this.removeRow(element)

      } else {
        // Action was cancelled
        console.log('Action cancelled');
      }
    });
  }

  ngOnDestroy():void{

    this.unsubscribe$.unsubscribe()
    this.onClick.unsubscribe()
    
  }




}
